import styled, { css } from 'styled-components';
import { query, font, color, space } from '@design/templateFns';

export const StyledDescription = styled.p`
  ${font('body-md-light')};
  padding-bottom: 0;
  margin-bottom: ${space('xl')};
  color: ${color('gray5')};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;

  @media screen and (${query.below('desktop')}) {
    ${font('body-sm-light')};
    margin-bottom: ${space('lg')};
  }
`;

export const StyledDate = styled.p`
  display: inherit;
  ${font('eyebrow-sm')};
  text-transform: uppercase;
  color: ${color('gray4')};
  padding: 0 0 29px;
  margin: 0;
  span {
    font-weight: 700;
  }
`;
